import React from "react";

const AdminNavbarAppearanceContext = React.createContext(null);

export function AdminNavbarAppearanceProvider({ value, children }) {
  return (
    <AdminNavbarAppearanceContext.Provider value={value}>
      {children}
    </AdminNavbarAppearanceContext.Provider>
  );
}

export function useAdminNavbarAppearance() {
  const ctx = React.useContext(AdminNavbarAppearanceContext);
  if (!ctx) {
    throw new Error(
      "useAdminNavbarAppearance must be used within AdminNavbarTheme1 or AdminNavbarTheme2"
    );
  }
  return ctx;
}
